/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimes, faArrowUp, faArrowDown, faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

require('./bootstrap');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

library.add(faTimes);
library.add(faArrowUp);
library.add(faArrowDown);
library.add(faSearch);

Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.component('home', require('./components/Home.vue').default);
Vue.component('orcamentos', require('./components/Orcamento.vue').default);
Vue.component('lotes', require('./components/Lotes.vue').default);
Vue.component('base-dados-orcamentos', require('./components/BaseDadosOrcamentos.vue').default);
Vue.component('editar-orcamento', require('./components/NovoOrcamento.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
